import type { TranslationKey } from "../locales";
import type { Enums } from "../types";

export function getAlertTranslationKey(level: Enums<"alertLevelType">): TranslationKey {
	switch (level) {
		case "danger":
			return "dashboard.alerts.level_types.danger";
		case "info":
			return "dashboard.alerts.level_types.info";
		case "neutral":
			return "dashboard.alerts.level_types.neutral";
		case "success":
			return "dashboard.alerts.level_types.success";
		case "warning":
			return "dashboard.alerts.level_types.warning";
	}
}
